import { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import {
  Container,
  Typography,
  Button,
  Alert,
  LinearProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AuthContext from '../AuthContext';
import { apiFetch, apiFetchText } from '../api';

export default function LasFilesPage() {
  const { id } = useParams();
  const { token } = useContext(AuthContext);
  const [log, setLog] = useState(null);
  const [files, setFiles] = useState(null);
  const [contents, setContents] = useState({});
  const [expanded, setExpanded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const logResp = await apiFetch(`/api/logs/${id}/`);
        if (!logResp.ok) {
          throw new Error('Failed to fetch log');
        }
        const logData = await logResp.json();
        setLog(logData);

        const response = await apiFetch(`/api/logs/${id}/las-files/`);
        if (!response.ok) {
          throw new Error('Failed to fetch LAS files');
        }
        const data = await response.json();
        setFiles(data);
      } catch (err) {
        setError(err.message);
      }
    };
    fetchData();
  }, [id]);

  const handleChange = (fileId) => async (event, isExpanded) => {
    if (isExpanded && !contents[fileId]) {
      try {
        const text = await apiFetchText(`/api/logs/${id}/las-files/${fileId}/`);
        setContents((prev) => ({ ...prev, [fileId]: text }));
      } catch (err) {
        setError(err.message);
      }
    }
    setExpanded(isExpanded ? fileId : false);
  };

  const handleDownload = (fileId) => {
    const base = process.env.REACT_APP_API_BASE_URL || '';
    const url = token
      ? `${base}/api/logs/${id}/las-files/${fileId}/?token=${token}`
      : `${base}/api/logs/${id}/las-files/${fileId}/`;
    window.location.href = url;
  };

  if (error) {
    return (
      <Container sx={{ py: 4 }}>
        <Alert severity="error">{error}</Alert>
      </Container>
    );
  }

  if (!log || files === null) {
    return (
      <Container sx={{ py: 4 }}>
        <LinearProgress />
      </Container>
    );
  }

  return (
    <Container sx={{ py: 4, textAlign: 'left' }}>
      <Typography variant="h4" component="h1" gutterBottom>
        {`LAS Files for ${log.visible_name || log.file.split('/').pop()}`}
      </Typography>
      {files.map((file) => (
        <Accordion
          key={file.id}
          expanded={expanded === file.id}
          onChange={handleChange(file.id)}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>{file.name}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Button
              variant="contained"
              onClick={() => handleDownload(file.id)}
              sx={{ mb: 2 }}
            >
              Download
            </Button>
            {contents[file.id] ? (
              <pre
                style={{
                  background: '#f5f5f5',
                  padding: '1rem',
                  overflowX: 'auto',
                  fontFamily: 'monospace',
                  textAlign: 'left',
                }}
              >
                {contents[file.id]}
              </pre>
            ) : (
              <LinearProgress />
            )}
          </AccordionDetails>
        </Accordion>
      ))}
    </Container>
  );
}

